import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core'
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms'
import moment from 'moment'
import {merge, Subject} from 'rxjs'
import {map, startWith, takeUntil, tap} from 'rxjs/operators'

@Component({
  selector: 'mypayter-portal-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class DatetimePickerComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  date: FormControl
  time: FormControl
  destroy$ = new Subject<void>()

  constructor(private fb: FormBuilder) {
    this.date = new FormControl(moment().toDate(), [])
    this.time = new FormControl(moment().toDate(), [])
  }
  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
  writeValue(obj: any): void {
    if (obj) {
      this.date.setValue(moment(obj).toDate())
    } else {
      this.date.setValue(moment().toDate())
    }
  }
  registerOnChange(fn: any): void {
    merge(
      this.date.valueChanges.pipe(startWith(this.date.value)),
      this.time.valueChanges.pipe(startWith(this.time.value)),
    )
      .pipe(
        takeUntil(this.destroy$),
        map((r) => moment(r).valueOf()),
      )
      .subscribe(fn)
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }

  ngOnInit() {
    // forms need to sync
    this.date.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        tap((r) =>
          this.time.setValue(r, {
            onlySelf: true,
            emitEvent: false,
          }),
        ),
      )
      .subscribe()

    this.time.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        tap((r) =>
          this.date.setValue(r, {
            onlySelf: true,
            emitEvent: false,
          }),
        ),
      )
      .subscribe()
  }
}
